<template>
  <div class="certificate-verify-container">
    <!-- 顶部标题 -->
    <div class="header">
      <h2>证书验真查询</h2>
    </div>

    <!-- 查询表单 -->
    <div class="form-container">
      <van-field v-model="code" label="证书编号" placeholder="请输入证书编号" clearable input-align="right" />

      <van-field v-model="projectCode" label="项目编号" placeholder="请输入项目编号" clearable input-align="right" />

      <van-button type="danger" block @click="handleQuery" :loading="loading" class="query-btn">
        查询
      </van-button>
    </div>

    <!-- 查询结果 - 证书信息 -->
    <div class="result-container" v-if="showResult">
      <div class="certificate-header">
        <h3>上海卒中学会证书查询</h3>
      </div>

      <!-- 证书图片预览 -->
      <van-image v-if="certificateImage" :src="certificateImage" fit="contain" @click="showImagePreview" class="certificate-image" />

      <van-image-preview v-model="showPreview" :images="[certificateImage]" />
    </div>

    <!-- 加载状态 -->
    <van-loading v-if="loading" class="loading" />
  </div>
</template>

<script>
import { getOneCertificate } from '@/http/request'
export default {
  data() {
    return {
      code: '',
      projectCode: '',
      loading: false,
      showResult: false,
      showPreview: false,
      certificateImage: ''
    }
  },
  methods: {
    handleQuery() {
      if (!this.code || !this.projectCode) {
        this.$toast('请输入证书编号和项目编号');
        return;
      }

      this.loading = true;
      getOneCertificate({
        code: this.code,
        projectCode: this.projectCode
      }).then(({data}) => {
        console.log("data", data)
        if(!data.code) {
          this.showResult = true;
          this.certificateImage = data.data;
        }else {
          this.$toast(data.msg);
        }
      }).catch(err => {
        this.$toast(err.msg);
      }).finally(() => {
        this.loading = false;
      })
    },

    showImagePreview() {
      this.showPreview = true;
    }
  }
}
</script>

<style scoped>
.certificate-verify-container {
  padding: 15px;
  max-width: 100%;
  margin: 0 auto;
  background-color: #f7f7f7;
  min-height: 100vh;
}

.header {
  text-align: center;
  margin-bottom: 25px;
}

.header h2 {
  color: #ee0a24;
  font-size: 20px;
  font-weight: bold;
}

.form-container {
  margin-bottom: 20px;
  background-color: #fff;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.form-container .van-field {
  margin-bottom: 15px;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
}

.form-container .van-field:last-child {
  margin-bottom: 20px;
}

.query-btn {
  background-color: #ee0a24;
  border: none;
  height: 44px;
  border-radius: 4px;
  font-size: 16px;
}

.result-container {
  margin-top: 20px;
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.certificate-header {
  text-align: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #f0f0f0;
}

.certificate-header h3 {
  font-size: 18px;
  color: #333;
  font-weight: bold;
}

.certificate-content {
  margin-bottom: 20px;
}

.certificate-info {
  margin-bottom: 20px;
}

.info-row {
  display: flex;
  margin-bottom: 12px;
  font-size: 14px;
}

.info-label {
  color: #666;
  width: 80px;
  text-align: right;
}

.info-value {
  color: #333;
  flex: 1;
}

.certificate-footer {
  margin-top: 25px;
  text-align: center;
}

.recipient {
  font-size: 15px;
  color: #333;
  line-height: 1.6;
}

.certificate-image {
  width: 100%;
  margin-top: 20px;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
}

.loading {
  display: block;
  margin: 30px auto;
}
</style>